module.exports = __webpack_public_path__ + "4876542043_4d94fced5c_o.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4876542043_4d94fced5c_o.jpg
// module id = 831
// module chunks = 0